// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__i8zwi","PageNumber":"Pagination_PageNumber__3_ab4","PageNumber_NotActive":"Pagination_PageNumber_NotActive__CSUll"};